/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Birthday_OfInputs */

const fr_calendar_birthday_of = /** @type {(inputs: Calendar_Birthday_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anniversaire de `)
};

/**

* @param {Calendar_Birthday_OfInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_of = /** @type {((inputs?: Calendar_Birthday_OfInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_OfInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_of(inputs)
});